import React, { useState } from 'react';
import { Box, Flex, Text, Button, Image, Drawer, DrawerOverlay, DrawerContent, Divider, useBreakpointValue } from '@chakra-ui/react';
import Clock from '../Assets/Icons/clock.gif';
import clock_done from '../Assets/Icons/clock_done.gif';
import check from '../Assets/Icons/check.svg';
import circle_star from '../Assets/Icons/circle_star.svg';
import ModalTemplate from '../../common/ModalTemplate';
import RequestCallback from '../../common/V2/RequestCallback';
import { useGetRequestCallback } from '../../../hooks/V2/useRequestCallback';

interface Props {
	isOpen: boolean;
	onOpen: () => void;
	onClose: () => void;
	isEligibleforEliteProgram?: string;
}
const EliteProgramDrawer = ({ isOpen, onOpen, onClose, isEligibleforEliteProgram }: Props) => {
	const isMobile = useBreakpointValue({ base: true, md: false });
	const sourceType = 'eliteEligible';
	const [toggleDrawer, setToggleDrawer] = useState(false);
	return (
		<>
			{isMobile ? (
				<Drawer placement={'bottom'} onClose={onClose} size={'xl'} isOpen={isOpen}>
					<DrawerOverlay />
					<DrawerContent bg="white" w="100%" borderRadius="40px 40px 0 0" backgroundColor="#FFF9E5">
						<DrawerContentData setToggleDrawer={setToggleDrawer} onClose={onClose} isEligibleforEliteProgram={isEligibleforEliteProgram} />
					</DrawerContent>
				</Drawer>
			) : (
				<ModalTemplate
					title=""
					marginX={2}
					isOpen={isOpen}
					bgColor="white"
					maxWidth="500px"
					showCloseButton={true}
					showCloseButtonIcon={true}
					modalContentProps={{ shadow: 'none', p: '0px' }}
					modalOverlayProps={{ bg: 'rgba(1, 10, 27, 0.80)' }}
					onClose={() => onClose()}
				>
					<DrawerContentData setToggleDrawer={setToggleDrawer} onClose={onClose} isEligibleforEliteProgram={isEligibleforEliteProgram} />
				</ModalTemplate>
			)}
			<RequestCallback sourceType={sourceType} openCallbackDrawer={toggleDrawer} setOpenCallbackDrawer={setToggleDrawer} />
		</>
	);
};

interface DrawerContentDataProps {
	isEligibleforEliteProgram?: string;
	onClose: () => void;
	setToggleDrawer: (value: boolean) => void;
}

const DrawerContentData = ({ isEligibleforEliteProgram, onClose, setToggleDrawer }: DrawerContentDataProps) => {
	const [openCallbackDrawer, setOpenCallbackDrawer] = useState(false);
	const { data: getCallbacksData, isLoading: getCallbacksLoading } = useGetRequestCallback('eliteEligible');
	console.log("Elite",getCallbacksData)

	return (
		<Flex alignItems="end">
			<Box
				display="flex"
				flexDirection="column"
				position="relative"
				overflow="hidden"
				boxShadow="0px -8px 32px 0px rgba(0, 0, 0, 0.10);"
				bg="white"
				w="100%"
				borderRadius={{ base: '40px 40px 0 0', md: '16px' }}
				backgroundColor="#FFF9E5"
			>
				<Divider
					display={{ md: 'none' }}
					style={{
						width: '56px',
						height: '3px',
						borderRadius: '4px',
						flexShrink: 0,
						backgroundColor: '#595959',
						margin: '24px auto 0',
					}}
				/>
				<Box position="absolute" right="0" top="0">
					<Image src={circle_star} alt="circle_stars" />
				</Box>
				<Text
					as={'h4'}
					textAlign="center"
					color="#4358F6"
					fontFamily="Poppins"
					fontSize="20px"
					fontStyle="normal"
					fontWeight="700"
					lineHeight="28px"
					marginTop="24px"
				>
					Prepleaf Elite Program
				</Text>
				<Text textStyle="body2" fontStyle="normal" color="#03081A" textAlign="center" fontFamily="Open Sans" margin="8px auto 16px">
					which includes
				</Text>
				<Box textStyle="body1-md" fontFamily="Open Sans" margin="auto 39px auto 16px" color="#3B3435" display={'grid'} gap={'12px'}>
					<Flex gap={'12px'} alignItems={'center'}>
						<Image src={check} alt="click" />
						<Text textStyle="body1-md">2 months of free training</Text>
					</Flex>
					<Flex gap={'12px'} alignItems={'center'}>
						<Image src={check} alt="click" />
						<Text>Tutored by industry experts</Text>
					</Flex>
					<Flex gap={'12px'} alignItems={'center'}>
						<Image src={check} alt="click" />
						<Text>Job opportunities</Text>
					</Flex>
				</Box>
				<Box
					display="flex"
					borderRadius="12px"
					border="1.4px solid #CC926E"
					background="#fff"
					margin="23px 16px 35px"
					alignItems="center"
					justifyContent="center"
				>
					{isEligibleforEliteProgram === 'eligible' ? (
						<Image h="70px" w="70px" flexShrink="0" objectFit="cover" src={clock_done} alt="" />
					) : (
						<Image h="70px" w="70px" flexShrink="0" objectFit="cover" src={Clock} alt="" />
					)}
					{isEligibleforEliteProgram === 'eligible' ? (
						getCallbacksData && getCallbacksData.source === 'eliteEligible' && getCallbacksData.status === 'Booked' ? (
							<Text color="#CC926E" textStyle="body1-md" fontFamily="Open Sans" padding={'8px'}>
								Session has been scheduled successfully. Someone from our team will reach out to you.
							</Text>
						) : (
							<Text color="#CC926E" textStyle="body1-md" fontFamily="Open Sans" padding={'10px'}>
								For more details schedule a session, and our team will get in touch with you.
							</Text>
						)
					) : (
						<Text color="#CC926E" textStyle="body1-md" fontFamily="Open Sans" padding={'8px'}>
							Please come back after 72 hours to check your result status.
						</Text>
					)}
				</Box>
				<Box
					display="inline-flex"
					padding="12px 14px 12px 14px"
					justifyContent="flex-end"
					alignItems="center"
					bgColor="#fff"
					boxShadow="0px -8px 32px 0px rgba(0,0,0,0.10)"
				>
					<Button
						bgColor={'#4358F6'}
						w="100%"
						variant={'primary'}
						isDisabled={
							isEligibleforEliteProgram !== 'eligible' ||
							(getCallbacksData && getCallbacksData.source === 'eliteEligible' && getCallbacksData.status === 'Booked')
								? true
								: false
						}
						onClick={() => {
							setToggleDrawer(true);
							setOpenCallbackDrawer(true);
							onClose();
						}}
					>
						Schedule
					</Button>
				</Box>
			</Box>
		</Flex>
	);
};

export default EliteProgramDrawer;
